export default __webpack_public_path__ + "static/media/font-porfolio.ff21455d.png";